import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/HomePage'
import Business from '@/pages/Business'
import Products from '@/pages/Products'
import TeamPage from '@/pages/TeamPage'
import NewsPage from '@/pages/NewsPage'
import NewsDetailPage from '@/pages/NewsDetailPage'
import BlitzPage from '@/pages/BlitzPage'
import ContactPage from '@/pages/ContactPage'
import LegalPage from '@/pages/LegalPage'
import CertPage from '@/pages/CertPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/Products-solutions',
      name: 'Products',
      component: Products
    },
    {
      path: '/team',
      name: 'Team',
      component: TeamPage
    },
    {
      path: '/news',
      name: 'News',
      component: NewsPage
    },
    {
      path: '/news/:id',
      name: 'News_detail',
      component: NewsDetailPage
    },
    {
      path: '/blitz',
      name: 'Blitz',
      component: BlitzPage
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactPage
    },
    {
      path: '/legal',
      name: 'Legal',
      component: LegalPage
    },
    {
      path: '/cert',
      name: 'Cert',
      component: CertPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js